export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8363.10173a79.jpg";